import { Button, Card, CardActions, CardContent, CardHeader, Container, CssBaseline, Dialog, DialogContent, DialogTitle, Grid, IconButton, List, ListItem, ListItemIcon, ListItemText, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react'
import MyBreadcrumbs from '../../../components/MyBreadcrumbs';
import DeleteIcon from '@mui/icons-material/Delete';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { AddCircleOutline, Dehaze, Save } from '@mui/icons-material';
import { arrayMoveImmutable } from 'array-move';
import { Controller, useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import axios from 'axios';
import { CustomDescrypt } from '../../../utils/MyEncryption';
import { base_url } from '../../../utils/GlobalVariables';
import Swal from 'sweetalert2';
import { AuthStore } from '../../../store/UserStore';

const breadcrumbItem = { '/verif': 'Home', '/verif/kelengkapan': 'Kelengkapan' };

const DragHandler = SortableHandle(() => <Dehaze sx={{ cursor: 'move' }} color='info' />);

const SortableContainerZ = SortableContainer(({ children }) => {
    return <List dense={false} sx={{ bgcolor: 'background.paper' }}>{children}</List>;
});

const SortableItem = SortableElement(({ value, onDelete }) => {
    return <ListItem
        // sx={{ pb: 1 }}
        disablePadding
        secondaryAction={
            <IconButton edge="end" aria-label="delete" onClick={onDelete}>
                <DeleteIcon color='error' />
            </IconButton>
        }
    >
        <ListItemIcon>
            <IconButton>
                <DragHandler />
            </IconButton>
        </ListItemIcon>
        <ListItemText primary={value} secondary={null} />
    </ListItem>
});

const InputDialog = ({ openDialog, handleCloseDialog, menyimpan, setMenyimpan }) => {
    const logOut = AuthStore((state) => state.logOut);
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const { handleSubmit, control, reset } = useForm();
    const [loading, setLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        setIsOpen(openDialog)
    }, [openDialog])

    const onSubmit = (data) => {
        console.log(data);
        setLoading(true);
        axios.post(
            base_url + '/kelengkapan/insert',
            data,
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`,
                    'content-type': 'multipart/form-data'
                }
            })
            .then((response) => {
                setLoading(false);

                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil',
                    text: response.data.msg
                })
                console.log(response);
                reset();
                handleCloseDialog()
                setMenyimpan(!menyimpan)
                // navigate(-1)
            })
            .catch((error) => {
                console.log(error);
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: error.response.status + " " + error.response.statusText,
                        text: error.response.data.message
                    })
                }
                setLoading(false)
            })
    }

    return (
        <Dialog
            fullWidth={true}
            maxWidth="sm"
            open={isOpen}
            onClose={handleCloseDialog}
            scroll="paper"
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <DialogTitle id="scroll-dialog-title">Detail Data</DialogTitle>
            <DialogContent>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2} sx={{ py: 2 }}>
                        <Grid item xs={12} sx={{ textAlign: "center" }}>
                            <Controller
                                name="kelengkapan"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                    <TextField
                                        required
                                        fullWidth
                                        id="standard-basic"
                                        label="Kelengkapan Dokumen"
                                        variant="standard"
                                        margin="normal"
                                        onChange={onChange}
                                        defaultValue={value}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} py={2} justifyContent="flex-end">
                        <Grid item >
                            <LoadingButton
                                loading={loading}
                                variant="contained"
                                margin="normal"
                                loadingPosition="start"
                                startIcon={<Save />}
                                type='submit'
                            >
                                Simpan
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </form>
            </DialogContent>

        </Dialog>
    );
}

const Kelengkapan = () => {
    const logOut = AuthStore((state) => state.logOut);
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [items, setItems] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [disableSimpan, setDisableSimpan] = useState(true)
    const [menyimpan, setMenyimpan] = useState(false)

    const onSortEnd = ({ oldIndex, newIndex }) => {
        setItems(arrayMoveImmutable(items, oldIndex, newIndex));
        setDisableSimpan(false)
        console.log(items);
    };

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    useEffect(() => {
        requestData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [menyimpan]);

    const requestData = () => {
        // setTableLoading(true)
        axios.get(
            base_url + '/kelengkapans',
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`
                }
            })
            .then((response) => {
                const data = response.data;
                setItems(data.kelengkapans)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: error.response.status + " " + error.response.statusText,
                        text: error.response.data.message
                    })
                }
            })
    }

    const updateKelengkapans = () => {
        Swal.fire({
            title: 'Update Data?',
            text: "Urutan Data akan berubah",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            showLoaderOnConfirm: true,
            confirmButtonText: 'Ya, Update!',
            cancelButtonText: 'Batal',
            preConfirm: () => {
                console.log(items);
                return axios.post(
                    base_url + '/kelengkapan/reorder',
                    {
                        _method: "PUT",
                        data: JSON.stringify(items)
                    },
                    {
                        headers: {
                            'Authorization': `Bearer ${decryptedUser.token}`,
                            'content-type': 'multipart/form-data'
                        }
                    })
                    .then((response) => {
                        requestData();
                        setDisableSimpan(true)
                        return response.data
                    })
                    .catch((error) => {
                        if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                            logOut();
                        }
                        else {
                            console.log(error.response);
                            Swal.showValidationMessage(
                                `Request failed: ${error.response.statusText}`
                            )
                        }
                    })
            },
            backdrop: true,
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            console.log(result);
            if (result.isConfirmed) {
                Swal.fire(
                    'Selesai!',
                    result.value.msg,
                    'success'
                )
            }
        })
    }

    const deleteData = (params) => {
        const frmData = {
            _method: 'DELETE',
            id: params
        }

        Swal.fire({
            title: 'Hapus Data?',
            // text: "!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            showLoaderOnConfirm: true,
            confirmButtonText: 'Ya, Hapus!',
            cancelButtonText: 'Batal',
            preConfirm: () => {
                return axios.post(
                    base_url + '/kelengkapan/hapus',
                    frmData,
                    {
                        headers: {
                            'Authorization': `Bearer ${decryptedUser.token}`,
                            'content-type': 'multipart/form-data'
                        }
                    })
                    .then((response) => {
                        requestData();
                        return response.data
                    })
                    .catch((error) => {
                        if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                            logOut();
                        }
                        else {
                            console.log(error.response);
                            Swal.showValidationMessage(
                                `Request failed: ${error.response.statusText}`
                            )
                        }
                    })
            },
            backdrop: true,
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            console.log(result);
            if (result.isConfirmed) {
                Swal.fire(
                    'Selesai!',
                    result.value.msg,
                    'success'
                )
            }
        })
    }

    return (
        <>
            <CssBaseline />
            <MyBreadcrumbs breadcrumbItem={breadcrumbItem} title="VERIFIKATOR" />
            <Container sx={{ my: 3 }} fixed>
                <Grid container spacing={2} direction="row"
                    justifyContent="center"
                >
                    <Grid item xs={12} md={8}>
                        <Card>
                            <CardHeader
                                title="Kelengkapan Dokumen"
                                action={
                                    <Button
                                        variant="outlined"
                                        endIcon={<AddCircleOutline color='white' />}
                                        onClick={() => handleOpenDialog()}
                                    // to="/bnd/spm/add"
                                    // component={Link}
                                    >
                                        Tambah
                                    </Button>
                                }
                            />
                            <CardContent sx={{ mb: 2, height: 700, overflowY: "scroll" }}>
                                {
                                    items.length > 0 &&

                                    <SortableContainerZ onSortEnd={onSortEnd} useDragHandle>
                                        {items.map((value, index) => (
                                            // console.log(value);
                                            <SortableItem key={value.id} index={index} value={value.kelengkapan} onDelete={() => deleteData(value.id)} />
                                        ))}
                                    </SortableContainerZ>
                                }
                            </CardContent>
                            <CardActions sx={{display: "flex", justifyContent: "flex-end"}} >
                                <Button disabled={disableSimpan} variant='contained' startIcon={<Save />} onClick={updateKelengkapans}>Simpan</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                </Grid>
            </Container>
            <InputDialog openDialog={openDialog} handleCloseDialog={handleCloseDialog} menyimpan={menyimpan} setMenyimpan={setMenyimpan}/>
        </>
    )
}

export default Kelengkapan